module.exports = __webpack_public_path__ + "media/images/flags/nu-6befb41c86d857fffe16761835048047.svg";